/*
 * @Author       : Archer<ahh666@qq.com>
 * @Date         : 2023-02-06 10:08:03
 * @LastEditors  : Archer<ahh666@qq.com>
 * @LastEditTime : 2023-02-07 10:36:14
 * @FilePath     : \youxi\youxi\src\views\LeaveMsg\index.jsx
 * @Description  : Description
 */
const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
  navigator.userAgent
);
export default {
  created() {
    if (isMobile) {
      return false;
    }
    this.$leaveMsg();
  }
};
